export enum AreaUnitEnum {
  km2 = 'km2',
  m2 = 'm2',
}
